import { Box, Typography, Grid } from "@mui/material";
import { Assessment, BarChart, Psychology, Article, AutoGraph, Visibility } from "@mui/icons-material";

const dataPoints = [
  { 
    icon: <Assessment fontSize="large" sx={{ fontSize: 80, color: "#172554" }} />, 
    title: "Data Collection & Interpretation", 
    description: "Collecting data from reliable sources and transforming raw information into meaningful insights. This process ensures accuracy and relevance in research, enabling informed decision-making. Proper interpretation helps uncover patterns, trends, and key findings for better analysis." 
  },
  { 
    icon: <BarChart fontSize="large" sx={{ fontSize: 80, color: "#172554" }} />, 
    title: "Statistical Analysis & Testing", 
    description: "Utilizing statistical techniques to analyze datasets and validate research hypotheses. Methods such as regression analysis, ANOVA, and probability distributions enhance data reliability. These analyses help derive meaningful conclusions and support data-driven decisions." 
  },
  { 
    icon: <Psychology fontSize="large" sx={{ fontSize: 80, color: "#172554" }} />, 
    title: "Hybrid Algorithm Development", 
    description: "Designing and implementing hybrid algorithms that combine multiple computational techniques. These solutions optimize efficiency, accuracy, and automation in machine learning, data science, and problem-solving. Hybrid methods enhance performance across complex domains." 
  },
  { 
    icon: <Visibility fontSize="large" sx={{ fontSize: 80, color: "#172554" }} />, 
    title: "Computer Vision Applications", 
    description: "Developing AI-powered solutions for visual data processing, including image recognition and object detection. Computer vision enhances automation in industries like security, healthcare, and robotics. These systems enable machines to analyze and interpret images efficiently." 
  },
  { 
    icon: <Article fontSize="large" sx={{ fontSize: 80, color: "#172554" }} />, 
    title: "Article Writing & Publishing", 
    description: "Creating well-researched academic and technical articles for journals and conferences. Ensuring clarity, structure, and adherence to publishing standards. Well-written publications enhance credibility, improve knowledge sharing, and contribute to research impact." 
  },
  { 
    icon: <AutoGraph fontSize="large" sx={{ fontSize: 80, color: "#172554" }} />, 
    title: "Machine & Deep Learning Solutions", 
    description: "Building machine learning and deep learning models for automation, analytics, and AI-driven applications. Using frameworks like TensorFlow and PyTorch to develop intelligent solutions. These models optimize decision-making, prediction accuracy, and data analysis." 
  }
];


const DessertationDataAnalysis = () => {
  return (
    <Box sx={{ p: 6, maxWidth: "100%", margin: "auto" }}>
      <Typography
        variant="h5"
        fontWeight={600}
        gutterBottom
        textAlign={"center"}
        color={"#172554"}
        sx={{ fontSize: { xs: "20px", sm: "24px", md: "28px" } }}
      >
        Advanced{" "}
        <span
          style={{
            background:
              "linear-gradient(-96deg, rgb(255 255 255 / 0%) 0%, rgb(255 249 220 / 0%) 28%, rgb(253, 103, 16) 100%, rgb(255 255 255 / 0%) 100%)",
            padding: "0px 5px",
          }}
        >
          Data Analysis &
        </span>{" "}Interpretation
      </Typography>
      <Grid container spacing={6}>
        {dataPoints.map((item, index) => (
          <Grid item xs={12} md={6} key={index}>
            <Box
              sx={{
                display: "flex",
                alignItems: { xs: "flex-start", sm: "center" },
                flexDirection: { xs: "column", sm: "row" },
                border: "2px solid #172554",
                borderRadius: "12px",
                padding: 3,
              }}
            >
              <Box sx={{ mr: { sm: 4 }, mb: { xs: 2, sm: 0 } }}>{item.icon}</Box>
              <Box>
                <Typography variant="h6" color="black" fontWeight={600} sx={{ fontSize: { xs: "18px", sm: "20px", md: "22px" } }}>{item.title}</Typography>
                <Typography variant="body1" color="black" sx={{ fontSize: { xs: "14px", sm: "16px" }, lineHeight: { xs: "1.4", sm: "1.6" } }}>{item.description}</Typography>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default DessertationDataAnalysis;